// 探索周边
import fetch, {postForm} from '@/utils/fetch';
import { getToken,  } from '@/utils';

// 获取项目列表
export const getProjectList = async function(params) {
  return fetch({
    url: '/windfarm/project/getProjectList',
    method: 'get',
    params: {
      apiKey: getToken(),
      ...params,
    },
    showError: true,
  });
};

// 获取项目列表(不带分页)
export const getAllProjectList = async function(params) {
  return fetch({
    url: '/windfarm/project/getAllProjectList',
    method: 'get',
    params: {
      apiKey: getToken(),
      ...params,
    },
    showError: true,
  });
};

// 新建项目

export const createProject = async function(params) {
  return postForm({
    url: '/windfarm/project/createProject',
    method: 'post',
    data: {
      apiKey: getToken(),
      ...params,
    },
    showError: true,
  });
};

// 修改项目

export const updateProjectName = async function(params) {
  return postForm({
    url: '/windfarm/project/updateProject',
    method: 'post',
    data: {
      apiKey: getToken(),
      ...params,
    },
    showError: true,
  });
};
// 删除项目
export const deleteProjectApi = async function(params) {
  return postForm({
    url: '/windfarm/project/deleteProject',
    method: 'post',
    data: {
      apiKey: getToken(),
      ...params,
    },
    showError: true,
  });
};

// 更新项目审核状态
export const updateProjectState = async function(params) {
  return postForm({
    url: '/windfarm/project/updateProjectState',
    method: 'post',
    data: {
      apiKey: getToken(),
      ...params,
    },
    showError: true,
  });
};

export const downReport = async function(params) {
  return postForm({
    url: '/windfarm/stationReport/downReport',
    method: 'post',
    data: {
      apiKey: getToken(),
      ...params,
    },
    showError: true,
  });
};


export const getEconomicResultList = async function(params) {
  return postForm({
    url: '/windfarm/stationReport/getEconomicResultList',
    method: 'post',
    data: {
      apiKey: getToken(),
      ...params,
    },
    showError: true,
  });
};

// 根据风场获取默认方案的轮毂高度列表
export const getHeightListByProject = async function(params) {
  return fetch({
    url: '/windfarm/stationWX/getHeightListByProject',
    method: 'get',
    params: {
      apiKey: getToken(),
      ...params,
    },
    showError: true,
  });
};